module.exports = __webpack_public_path__ + "static/img/product1.0589760.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/red/product1.png
// module id = cUh2
// module chunks = 0